import React, { useEffect, useState } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material'
import useStyles from './styles'
import PageHeader from 'components/common/PageHeader'
import analyticsActions from './actions'
import LineChart from './graphs/LineChart'
import { useSelector } from 'react-redux'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import debounce from 'lodash/debounce';

const AnalyticsContainer = () => {
  const classes = useStyles()
  const { getUserActivityTime, getAllUsersActivityMinutes, getUserLoggedInActivity, getUsers, setUserActivityError } = analyticsActions()
  const { userLoggedInActivity, allUsersActivityMinutes, userActivityTime, users, userActivityError } = useSelector((state) => state.analytics)
  const options = [
    { label: 'Select User', id: null, key: 'Select User' }, 
    ...users.map(user => ({ label: `${user.firstname} ${user.lastname}`, id: user.id, key: user.id })),
  ];
  const [selectedUser, setSelectedUser] = useState(null);

  const handleUserChange = (event, newValue) => {
    setUserActivityError(false) 
    setSelectedUser(newValue);
  };

  const debouncedFetchUsers = debounce((searchTerm) => {
    
      getUsers(searchTerm.trim());
    
  }, 300);

  const handleInputChange = (event, value) => {
    debouncedFetchUsers(value);
  };


  const dailyActiveUserSeriesData = Object.keys(userLoggedInActivity).map(date => [Date.parse(date), userLoggedInActivity[date]]);
  const dailyActiveUsersOptions = {
    chart: {
      type: 'line'
    },
    title: {
      text: 'Number of Users Over Time'
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Number of Active Users'
      }
    },
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      shared: true
    },
    legend: {
      enabled: false, 
    },
    series: [{
      name: 'Active Users',
      data: dailyActiveUserSeriesData,
      marker: {
        enabled: true,
        radius: 3
      }
    }]
  };
  const allUsersActivityMinutesSeriesData = Object.keys(allUsersActivityMinutes).map(date => [Date.parse(date), allUsersActivityMinutes[date]]);
  const allUsersActivityMinutesOptions = {
    chart: {
      type: 'line'
    },
    title: {
      text: 'Total Time Spent by Users'
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Active Minutes spent each day'
      }
    },
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      shared: true
    },
    legend: {
      enabled: false, 
    },
    series: [{
      name: 'Active Minutes spent by all users',
      data: allUsersActivityMinutesSeriesData,
      marker: {
        enabled: true,
        radius: 3
      }
    }]
  };
  const daily_sessions = userActivityTime?.daily_sessions
  const userActivityTimeSeriesdata = daily_sessions?.map(daily_session => [Date.parse(daily_session.date), daily_session.total_session_duration_minutes]);

  const userActivityTimeOptions = {
    chart: {
      type: 'line'
    },
    title: {
      text: 'Select a User to View Time Spent'
    },
    xAxis: {
      type: 'datetime',
      title: {
        text: 'Date'
      }
    },
    yAxis: {
      title: {
        text: 'Active Minutes spent each day'
      }
    },
    tooltip: {
      xDateFormat: '%Y-%m-%d',
      shared: true
    },
    legend: {
      enabled: false, 
    },
    series: [{ 
      name:'Active Minutes spent',          
      data: userActivityTimeSeriesdata,
      marker: {
        enabled: true,
        radius: 3
      }
    }]
  };
  const renderSelectedUserActivity = () => {

    if (userActivityError) {
      return <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '300px',
          width: '100%',
          textAlign: 'center',
        }}
      ><Typography variant="h6">Selected User doesnt have any activity!</Typography></Box>
    }
    if (selectedUser?.id) {
      return <LineChart options={userActivityTimeOptions} seriesData={userActivityTimeSeriesdata} />
    }

    return null

  }



  useEffect(() => {
    selectedUser?.id && getUserActivityTime(selectedUser.id)
  }, [selectedUser?.id])
  useEffect(() => {
    getAllUsersActivityMinutes()
    getUserLoggedInActivity()


  }, [])
  // useEffect(() => {
  //   if (!selectedUser?.id) {
  //     setSelectedUser(options && options[0])
  //   }
  // }, [users])

  
  useEffect(() => {
    getUsers(selectedUser)
  }, [selectedUser])
  return (
    <Container>
      <PageHeader title="Analytics" />
      <Grid my={3}>
        <LineChart options={dailyActiveUsersOptions} seriesData={dailyActiveUserSeriesData} />
      </Grid>
      <Grid my={3}>
        <LineChart options={allUsersActivityMinutesOptions} seriesData={allUsersActivityMinutesSeriesData} />
      </Grid>
      <Typography variant="h6" sx={{my:'4px'}}>Select a user from the dropdown to their activity</Typography>
      <Grid sx={{minHeight: !selectedUser?.id?'420px':'50px'}}>
        <Autocomplete
          
          disablePortal
          value={selectedUser}
          onInputChange={handleInputChange}
          onChange={handleUserChange}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          filterOptions={(options) => options}
          options={options}
          renderOption={(props, option) => (
            <li {...props} key={option.id}>
              <div>
                {option.label}
              </div>
            </li>
          )}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params}  placeholder="Select User" label=" Select User" />}
        />

      </Grid>
      <Grid sx={{width:'100%', paddingBottom:'20px'}}>
        {renderSelectedUserActivity()}
      </Grid>
    </Container>

  )
}

export default AnalyticsContainer
